import { Place } from '../common';
import { ContactInfo } from '../common/contactInfo';

export const INVITATION_STATUSES = {
  PENDING: 'Pending',
  DISCONNECTED: 'Disconnected',
  ACTIVE: 'Active',
  // ON_REVIEW: 'OnReview',
  INVITED: 'Invited',
} as const;
export const INVITATION_STATUSES_LIST = Object.values(INVITATION_STATUSES);

export type OrganizationListItem = {
  id: string;
  name: string;
  tenantId: string;
  createdOn: string;
  contact: ContactInfo;
  address: Place;
  status: 'Pending' | 'Disconnected' | 'Active' | 'OnReview' | 'Invited';
};
